import env from './env';

const { RECAPTCHA_PUBLIC_KEY } = env;

const getCaptchaToken = () =>
  new Promise((resolve) => {
    window.grecaptcha.enterprise.ready(() => {
      window.grecaptcha.enterprise
        .execute(RECAPTCHA_PUBLIC_KEY, { action: 'login' })
        .then((token) => {
          resolve(token);
        })
        .catch(() => {});
    });
  });

export { getCaptchaToken, RECAPTCHA_PUBLIC_KEY };
